import PropTypes from 'prop-types';
import React from 'react';
import PureComponent from '../../pure';
import InputText from '../../formElements/InputText';
import sAction from 'sAction';

export default class ReportWindowColumn extends PureComponent {
    setWidth(value) {
        const prefix = this.props.prefix;
        const index = this.props.index;
        sAction.dataSet(prefix+ '/columns/' + index + '/def/width', value+'%');
    }

    render() {
        const data = this.props.data;
        const index = this.props.index;
        const vname = this.props.vname;
        const setWidth = this.props.setWidth;
        const allowLock = this.props.allowLock;
        const locked = this.props.locked;
        let show = false;

        if (data.def.get('show') === true || data.def.get('show') === undefined) {
            show = true;
        }
        return (
            <div key={index+data.name}
                className={show ? 'reportWindowColumn' : 'reportWindowColumn hidden'}
                data-name={data.name}
                data-way={index}>
                <span className="reportWindowColumnSpan">{vname}</span>
                {allowLock &&
                    <div className={'reportWindowColumnLockBtn' + (locked ? ' locked' : ' unlocked')}
                        onClick={() => this.props.setLock(data.name, !locked)}>{
                            locked ? <span className="iconfas-lock"></span> : <span className="iconfas-unlock"></span>
                        }
                    </div>
                }
                {setWidth && (
                    <InputText
                        type={'number'}
                        value={parseInt(data.def.get('width').replace('%', ''))}
                        onChange={(e) => this.setWidth(e.target.value.replace(/[^0-9]*/g, ''))}
                    />
                )}
            </div>
        );
    }
}

ReportWindowColumn.propTypes = {
    allowLock: PropTypes.any,
    data: PropTypes.shape({
        def: PropTypes.any,
        name: PropTypes.any,
    }),
    index: PropTypes.any,
    module: PropTypes.any,
    prefix: PropTypes.string,
    setWidth: PropTypes.any,
    vname: PropTypes.any,
    locked: PropTypes.bool,
    setLock: PropTypes.func,
};
